module.exports = __webpack_public_path__ + "static/media/billing.33cbd554.png";